export default "__VITE_ASSET__Bb6_d257__"